"use strict";
/*
 * Created on 01 04 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Generic representation of the concept of attribute of any entity with time validity. Time validity should be handled in special cases.
 *
 * Not all attributes are handled using this class, some of them are represented as flags (e.g. product's flags)
 *
 * @author JMe
 */


var EntityAttribute =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(EntityAttribute, _DomainObject_1$Domai);

  /**
   * @param id internal id entity representation
   * @param clazzId identification of a class (not internal id) to enable class name modification and so on
   * @param clazzName class class name (e.g. 'color' class)
   * @param attributeId identification of an attribute (not internal id) to enable attribute name modification and so on.
   * @param attributeName attribute value (e.g. 'blue', 'green' for 'color' class)
   * @param entityId internal id of an entity
   * @param validFrom start of validity of attribute on an entity
   * @param validTo end of validity of attribute on an entity
   */
  function EntityAttribute(id, clazzId, clazzName, attributeId, attributeName, entityId, validFrom, validTo) {
    var _this;

    _classCallCheck(this, EntityAttribute);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EntityAttribute).call(this));
    _this.id = id;
    _this.clazzId = clazzId;
    _this.clazzName = clazzName;
    _this.attributeId = attributeId;
    _this.attributeName = attributeName;
    _this.entityId = entityId;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    return _this;
  }

  return EntityAttribute;
}(DomainObject_1.DomainObject);

exports.EntityAttribute = EntityAttribute;

EntityAttribute.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(EntityAttribute.name);
  return {
    id: builder.id('id'),
    clazzId: builder.id('clazzId'),
    clazzName: builder.str('clazzName'),
    attributeId: builder.id('attributeId'),
    attributeName: builder.str('attributeName'),
    entityId: builder.id('entityId'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)
  };
}();